import React, {Component} from 'react';
import { PHILIPPINE_REGIONS } from '../../../utils/philippineRegions';
import Multiselect from 'multiselect-react-dropdown';
import SearchInput from '../../shared/components/forms/SearchInput';
import CurrencyInput from 'react-currency-input-field';

const multiSelectLabelCss = {
  width: "100%",
  marginBottom: "8px"
}

const multiSelectCss = {
  chips: {
    color: "#fff",
    background: "#5761F0",
    width: "max-content",
  },
  searchBox: {
    maxWidth: "100%",
    backgroundColor: "#fff",
    border: "solid #8082a9",
    borderRadius: "6px",
    width: "100%",
    marginTop: "2px",
    marginBottom: "4px",
    fontSize: "0.95em",
    fontFamily: "'Lota Grotesque Regular',sans-serif",
    letterSpacing: "-0.028em",
    padding: "12px"
  }
}

class Header extends Component {
  constructor(props) {
    super(props)
    this.state = {
      keyword: "",
      regions: [],
      min_amount: "",
      max_amount: "",
      sort_params: {sort_key: "", sort_direction: "DESC"},
      loading: false,
      error: {},
      errorText: "",
      showSearchSummary: false
    }
  }

  renderHeader() {
    return (
        <section className='landing-header-section'>
          <div className='left-header'>
            <h1 className='-white title'>Welcome to Project Finder!</h1>
            <ol>
              <li>Find government projects with one quick search</li>
              <li>Filter results by location and project value to find relevant projects faster</li>
              <li>Receive email alerts for projects relevant to your business on weekly or daily basis</li>
            </ol>
          </div>
          <div className='right-header filter-container transparent'>
              <SearchInput
                name="keyword"
                value={this.props.keyword}
                onClickButton={this.props.handleClickButton}
                onChange={event => this.props.handleChange(event)}
                placeholder="e.g. 'Web', 'Construction', 'Computer', ..."
              />
            <span className='-white fontBold'>Approved Budget Contract</span>
            <div className="ds-formGroup _marginBottom-none">
              <div class='ds-input'>
                <CurrencyInput
                  prefix={"₱"}
                  value={this.props.min_amount}
                  name="min_amount"
                  placeholder="₱50,000.00"
                  step={50000}
                  allowDecimals={true}
                  decimalScale={2}
                  allowNegativeValue={false}
                  onValueChange={(value, name) => this.props.handleValueChange(value, name)}
                  onKeyPress={event => this.props.handleAmountKeypress(event)}
                />
              </div>
              <div class='ds-input'>
                <CurrencyInput
                  prefix={"₱"}
                  value={this.props.max_amount}
                  name="max_amount"
                  placeholder="₱100,000.00"
                  step={50000}
                  allowDecimals={true}
                  decimalScale={2}
                  allowNegativeValue={false}
                  onValueChange={(value, name) => this.props.handleValueChange(value, name)}
                  onKeyPress={event => this.props.handleAmountKeypress(event)}
                />
              </div>
            </div>
            <div>
              <label style={multiSelectLabelCss}>
                <div>
                  <span className='-white'>Locations</span>
                </div>
                <Multiselect
                  isObject={false}
                  options={PHILIPPINE_REGIONS}
                  selectedValues={this.props.regions}
                  onSelect={this.props.multiSelectOnChange}
                  onRemove={this.props.multiSelectOnChange}
                  placeholder="Select Regions"
                  avoidHighlightFirstOption={true}
                  style={multiSelectCss}
                />
              </label>
            </div>
          </div>
        </section>
    )
  }

  render() {
    return (
      <div>
        {this.renderHeader()}
      </div>
    );
  }
}

export default Header;


// WEBPACK FOOTER //
// ./src/features/projectFinderLandingPage/components/Header.js